import { useQuery } from '@apollo/client';
import type { ListingsApi } from '@seek/sbiz-shared-types';
import { Heading, Notice, Stack, Text } from 'braid-design-system';
import React from 'react';

import Carousel from 'src/components/LegacyCarousel/LegacyCarousel';
import ListingCard from 'src/components/LegacyCarousel/components/ListingCard/ListingCard';
import { GetFeaturedFranchisesDocument } from 'src/generated/graphql';
import { isNonNullable } from 'src/utils';
import Section from 'src/views/Franchise/components/Section/Section';

const makeCarouselCards = (listingData: ListingsApi.FeaturedFranchise[]) => {
  const cards = listingData.map((listing, index) => (
    <span key={index} data-testid="carouselContent">
      <ListingCard htag={`featured-opportunity-item-${index}`} {...listing} />
    </span>
  ));
  return cards;
};

const FeaturedOpportunities = () => {
  const { data, loading, error } = useQuery(GetFeaturedFranchisesDocument, {
    variables: {},
  });
  // Change the following number if looking to render more franchises
  const displayedFranchises = 3;

  const listings =
    data?.featuredFranchises
      ?.filter(isNonNullable)
      .slice(0, displayedFranchises) ?? [];
  const emptyData = Array(displayedFranchises).fill({
    title: '',
    url: '',
    imageUrl: '',
    location: '',
    investment: '',
    htag: '',
  });

  return (
    <Section highlightBackground>
      <Stack space="medium">
        <Heading level="2">Featured opportunities</Heading>
        {error ? (
          <Notice tone="critical">
            <Text
              data={{
                testid: 'errorNotice',
              }}
            >
              Error getting Featured Franchises
            </Text>
          </Notice>
        ) : (
          <Carousel
            buttonOffsetTop={160}
            itemToShow={3}
            items={
              loading
                ? makeCarouselCards(emptyData)
                : makeCarouselCards(listings)
            }
          />
        )}
      </Stack>
    </Section>
  );
};

export default FeaturedOpportunities;
